// extracted by mini-css-extract-plugin
module.exports = {"done":"style__done__gJrTr","notDone":"style__notDone__vNVDs","labels":"style__labels__jvGNa"};